/**
=========================================================
* BASE: Learning Repository - v1.0.0
=========================================================

* Copyright 2022 Sean Dooley (https://www.dooley-dev.com)

Coded by www.dooley-dev.com

 =========================================================

* The above copyright notice shall be included in substantial portions of the Software.
*/
// React
import React from 'react';
// BASE Components
import BASESvgIcon from "../../../../@BASE/core/BASESvgIcon";
// material-ui
import IconButton from '@mui/material/IconButton';
import Paper from '@mui/material/Paper';
import Select from '@mui/material/Select';
import Typography from '@mui/material/Typography';
import MenuItem from '@mui/material/Menu';

function CommentCountCard(props) {
    const { status, variant, count, icon } = props;

    return (
        <Paper elevation={0} className="py-8 px-8 flex flex-col items-center w-full rounded-none">
            <div className="text-center">
                <Typography className={`text-xl sm:text-3xl font-bold tracking-tight leading-none ${variant}`}>
                    {String(count)}
                </Typography>
                <div className="flex flex-row items-center justify-center">
                    {/* <BASESvgIcon className="mr-4 text-secondary" size={16}>
                        {icon}
                    </BASESvgIcon> */}
                    <Typography className="text-12 font-medium" color="text.secondary">
                        {status}
                    </Typography>
                </div>
            </div>
        </Paper>
    );
}

export default CommentCountCard;
